import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon/pickUp.png'
import _imports_1 from '@/assets/img/icon/outsideTheIsland.png'
import _imports_2 from '@/assets/img/icon/drop.png'
import _imports_3 from '@/assets/img/icon/kurirDrop.png'
import _imports_4 from '@/assets/img/icon/deleteFilledAntDesignRed.svg'


const _hoisted_1 = { id: "agent-form" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 grid-cols-1" }
const _hoisted_3 = { class: "w-full px-5" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "codeAgent" }, "Kode Agen", -1)
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "tipeAgentOption" }, "Tipe Agen", -1)
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", { for: "address" }, "Alamat Lengkap", -1)
const _hoisted_12 = { class: "absolute top-0 " }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-map-marker " }),
  /*#__PURE__*/_createTextVNode(" Pilih alamat dengan maps")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "p-error"
}
const _hoisted_15 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_16 = { class: "p-col-12" }
const _hoisted_17 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "pi text-sm" }, "LAT", -1)
const _hoisted_19 = { class: "p-col-12" }
const _hoisted_20 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "pi text-sm" }, "LNG", -1)
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "nameAgent" }, "Nama Agen", -1)
const _hoisted_24 = {
  key: 0,
  class: "p-error"
}
const _hoisted_25 = { class: "mb-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { for: "phoneAgent" }, "Nomor Whatsapp", -1)
const _hoisted_27 = {
  key: 0,
  class: "p-error"
}
const _hoisted_28 = {
  key: 0,
  class: "p-field"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("label", { for: "idActive" }, "Aktif", -1)
const _hoisted_30 = { class: "w-full px-5" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = /*#__PURE__*/_createVNode("label", { for: "receiptCode" }, "Kode Resi", -1)
const _hoisted_33 = {
  key: 0,
  class: "p-error"
}
const _hoisted_34 = { class: "p-field mb-4" }
const _hoisted_35 = /*#__PURE__*/_createVNode("label", { for: "kotaOption" }, "Kota", -1)
const _hoisted_36 = {
  key: 0,
  class: "p-error"
}
const _hoisted_37 = { class: "p-field mb-4" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { for: "workingHour" }, "Jam Kerja Kurir", -1)
const _hoisted_39 = { class: "p-inputgroup w-full mt-1" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "p-inputgroup-addon" }, /*#__PURE__*/_toDisplayString('Jam'), -1)
const _hoisted_41 = {
  key: 0,
  class: "p-error"
}
const _hoisted_42 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_43 = { class: "p-col-12" }
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { for: "minCategory" }, "Komisi Spesial AA", -1)
const _hoisted_45 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_47 = { class: "p-col-12" }
const _hoisted_48 = /*#__PURE__*/_createVNode("label", { for: "minCategory" }, "Komisi Spesial AD", -1)
const _hoisted_49 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_51 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_52 = { class: "p-col-12" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { for: "minCategory" }, "Komisi Spesial DD", -1)
const _hoisted_54 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_55 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_56 = { class: "p-col-12" }
const _hoisted_57 = /*#__PURE__*/_createVNode("label", { for: "minCategory" }, "Komisi Spesial DA", -1)
const _hoisted_58 = { class: "flex p-input-icon-right mt-1 color-blue-grey" }
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "pi pi-percentage text-sm" }, null, -1)
const _hoisted_60 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_61 = { class: "p-field flex items-center mb-4" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("span", { class: "" }, "RIT 1")
], -1)
const _hoisted_63 = { class: "p-field flex items-center mb-4" }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("span", null, "RIT 2")
], -1)
const _hoisted_65 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_66 = { class: "p-field flex items-center mb-4" }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "object-contain w-6 mr-1",
    alt: "PickUp"
  }),
  /*#__PURE__*/_createVNode("span", {
    class: "",
    style: {"color":"#3C52C8"}
  }, "PickUp")
], -1)
const _hoisted_68 = { class: "p-field flex items-center mb-4" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "object-contain w-6 mr-1",
    alt: "LuarPulau"
  }),
  /*#__PURE__*/_createVNode("span", { style: {"color":"#C35972"} }, "Luar Pulau")
], -1)
const _hoisted_70 = { class: "grid gap-4 grid-cols-2 mb-4" }
const _hoisted_71 = { class: "p-field flex items-center mb-4" }
const _hoisted_72 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    class: "object-contain w-6 mr-1",
    alt: "Drop"
  }),
  /*#__PURE__*/_createVNode("span", { class: " color-primary" }, "Drop")
], -1)
const _hoisted_73 = { class: "p-field flex items-center mb-4" }
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    class: "object-contain w-6 mr-1",
    alt: "KurirDoor"
  }),
  /*#__PURE__*/_createVNode("span", { style: {"color":"#3CB129"} }, "Kurir Dooring")
], -1)
const _hoisted_75 = { class: "flex action-button px-5 py-5" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Simpan")
const _hoisted_77 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_78 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-3 h-3",
  alt: "delete"
}, null, -1)
const _hoisted_79 = {
  id: "mapDiv",
  ref: "mapDiv",
  style: {"width":"100%","height":"70vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_GoogleAutocomplete = _resolveComponent("GoogleAutocomplete")
  const _component_Maps = _resolveComponent("Maps")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "user-edit w-full" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                maxlength: "50",
                id: "codeAgent",
                class: "input-primary mt-1 uppercase w-full",
                name: "codeAgent",
                modelValue: _ctx.v$.codeAgent.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.codeAgent.$model = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              ((_ctx.v$.codeAgent.$invalid && _ctx.submitted) || _ctx.v$.codeAgent.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_6, _toDisplayString(_ctx.v$.codeAgent.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Multiselect, {
                id: "tipeAgentOption",
                class: "mt-1",
                modelValue: _ctx.v$.tipeAgentId.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.tipeAgentId.$model = $event)),
                placeholder: "Tipe Agen",
                options: _ctx.tipeAgentOption,
                searchable: true
              }, null, 8, ["modelValue", "options"]),
              ((_ctx.v$.tipeAgentId.$invalid && _ctx.submitted) || _ctx.v$.tipeAgentId.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_9, _toDisplayString(_ctx.v$.tipeAgentId.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("div", {
                class: "h-48 flex justify-center mt-2 relative items-center border-dotted  border-4 bg-yellow-100 border-yellow-500",
                onClick: _cache[3] || (_cache[3] = () => (_ctx.openMap = true))
              }, [
                _createVNode("span", _hoisted_12, _toDisplayString(_ctx.dataForm.address), 1),
                _hoisted_13
              ]),
              ((_ctx.v$.address.$invalid && _ctx.submitted) || _ctx.v$.address.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_14, _toDisplayString(_ctx.v$.address.required.$message), 1))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("span", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_InputText, {
                        type: "text",
                        disabled: "",
                        class: "input-primary w-full",
                        modelValue: _ctx.dataForm.Latitude,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataForm.Latitude = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("span", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_InputText, {
                        type: "text",
                        disabled: "",
                        class: "input-primary w-full",
                        modelValue: _ctx.dataForm.Longitude,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataForm.Longitude = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_InputText, {
                maxlength: "150",
                id: "nameAgent",
                class: "input-primary mt-1 w-full",
                name: "nameAgent",
                modelValue: _ctx.v$.nameAgent.$model,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.nameAgent.$model = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              ((_ctx.v$.nameAgent.$invalid && _ctx.submitted) || _ctx.v$.nameAgent.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_24, _toDisplayString(_ctx.v$.nameAgent.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_InputText, {
                maxlength: 13,
                minLength: 1,
                id: "phoneAgent",
                class: "input-primary mt-1 w-full",
                placeholder: "Pastikan Nomor Telephone Sudah Terhubung Dengan Whatsapp",
                name: "phoneAgent",
                modelValue: _ctx.v$.phoneAgent.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.phoneAgent.$model = $event)),
                type: "tel"
              }, null, 8, ["modelValue"]),
              ((_ctx.v$.phoneAgent.$invalid && _ctx.submitted) || _ctx.v$.phoneAgent.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_27, _toDisplayString(_ctx.v$.phoneAgent.required.$invalid
                          ? _ctx.v$.phoneAgent.required.$message
                          : _ctx.v$.phoneAgent.numeric.$invalid ?
                          _ctx.v$.phoneAgent.numeric.$message
                          : _ctx.v$.phoneAgent.minLength.$invalid ?
                          _ctx.v$.phoneAgent.minLength.$message
                          : _ctx.v$.phoneAgent.maxLength.$invalid ?
                          _ctx.v$.phoneAgent.maxLength.$message : ''), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.Id)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", null, [
                    _createVNode(_component_InputSwitch, {
                      id: "idActive",
                      class: "switch-og mt-1",
                      modelValue: _ctx.dataForm.isActive,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataForm.isActive = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_InputText, {
                maxlength: "50",
                id: "receiptCode",
                class: "input-primary mt-1 uppercase w-full",
                name: "receiptCode",
                modelValue: _ctx.v$.receiptCode.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.receiptCode.$model = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              ((_ctx.v$.receiptCode.$invalid && _ctx.submitted) || _ctx.v$.receiptCode.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_33, _toDisplayString(_ctx.v$.receiptCode.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_Multiselect, {
                id: "kotaOption",
                class: "mt-1",
                modelValue: _ctx.v$.kotaId.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.kotaId.$model = $event)),
                placeholder: "Kota",
                options: _ctx.kotaOption,
                searchable: true
              }, null, 8, ["modelValue", "options"]),
              ((_ctx.v$.kotaId.$invalid && _ctx.submitted) || _ctx.v$.kotaId.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_36, _toDisplayString(_ctx.v$.kotaId.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_37, [
              _hoisted_38,
              _createVNode("div", _hoisted_39, [
                _createVNode(_component_InputText, {
                  type: "number",
                  class: "input-primary rounded-lg w-full",
                  id: "workingHour",
                  modelValue: _ctx.v$.workingHour.$model,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.workingHour.$model = $event)),
                  placeholder: "Jam Kerja Untuk Kurir"
                }, null, 8, ["modelValue"]),
                _hoisted_40
              ]),
              ((_ctx.v$.workingHour.$invalid && _ctx.submitted) || _ctx.v$.workingHour.$pending.$response)
                ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(_ctx.v$.workingHour.required.$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("span", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_InputText, {
                    type: "number",
                    min: "0",
                    class: "input-primary w-full",
                    modelValue: _ctx.dataForm.komisiAA,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dataForm.komisiAA = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode("span", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_InputText, {
                    type: "number",
                    min: "0",
                    class: "input-primary w-full",
                    modelValue: _ctx.dataForm.komisiAD,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataForm.komisiAD = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_51, [
              _createVNode("div", _hoisted_52, [
                _hoisted_53,
                _createVNode("span", _hoisted_54, [
                  _hoisted_55,
                  _createVNode(_component_InputText, {
                    type: "number",
                    min: "0",
                    class: "input-primary w-full",
                    modelValue: _ctx.dataForm.komisiDD,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dataForm.komisiDD = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_56, [
                _hoisted_57,
                _createVNode("span", _hoisted_58, [
                  _hoisted_59,
                  _createVNode(_component_InputText, {
                    type: "number",
                    min: "0",
                    class: "input-primary w-full",
                    modelValue: _ctx.dataForm.komisiDA,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dataForm.komisiDA = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_60, [
              _createVNode("div", _hoisted_61, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.RIT1,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dataForm.RIT1 = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_62
              ]),
              _createVNode("div", _hoisted_63, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.RIT2,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dataForm.RIT2 = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_64
              ])
            ]),
            _createVNode("div", _hoisted_65, [
              _createVNode("div", _hoisted_66, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.CanPickup,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dataForm.CanPickup = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_67
              ]),
              _createVNode("div", _hoisted_68, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.IsLuarPulau,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dataForm.IsLuarPulau = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_69
              ])
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("div", _hoisted_71, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.CanDrop,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dataForm.CanDrop = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_72
              ]),
              _createVNode("div", _hoisted_73, [
                _createVNode(_component_Checkbox, {
                  binary: true,
                  modelValue: _ctx.dataForm.IsKurirDooring,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.dataForm.IsKurirDooring = $event)),
                  class: "checkbox-primary mr-3"
                }, null, 8, ["modelValue"]),
                _hoisted_74
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_75, [
          _createVNode(_component_Button, {
            class: "btn-primary text-black mr-3 px-10 py-1",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.submitData(!_ctx.v$.$invalid)))
          }, {
            default: _withCtx(() => [
              _hoisted_76
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-secondary text-black px-10 py-1",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.redirectBack()))
          }, {
            default: _withCtx(() => [
              _hoisted_77
            ]),
            _: 1
          }),
          (_ctx.Id)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "background-red-lighten-5 p-3 rounded-md cursor-pointer ml-3",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.deleteData()))
              }, [
                _hoisted_78
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    false
      ? (_openBlock(), _createBlock(_component_GoogleAutocomplete, {
          key: 0,
          onSendDetail: _ctx.setResultAddress,
          event: _ctx.addressRef,
          search: _ctx.dataForm.address
        }, null, 8, ["onSendDetail", "event", "search"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.openMap,
      "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => (_ctx.openMap = $event)),
      style: { width: '50vw' },
      dismissableMask: true,
      closeOnEscape: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Batal",
          icon: "pi pi-times",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.openMap = false)),
          class: "p-button-text"
        })
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_79, null, 512),
        _createVNode(_component_Maps, { onSendData: _ctx.receiveMapData }, null, 8, ["onSendData"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}